import React, { useEffect, useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import api from "services/api";

import { Card } from "@mui/material";
import PageviewIcon from "@mui/icons-material/Pageview";

import Tooltip from "@mui/material/Tooltip";

import DataTable from "examples/Tables/DataTable";
import Actionables from "components/UpStyled/Actionables";
import SuiBadge from "components/SuiBadge";
import SuiTypography from "components/SuiTypography";
import SuiBadgeDot from "components/SuiBadgeDot";
import SuiBox from "components/SuiBox";

import { capitalCase } from "capital-case";
import { AccountContext } from "context/account";
import Prompt from "components/UpStyled/Prompt";
import toast from "react-hot-toast";
import moment from "moment";
import qs from "query-string";
import Moodboard from "pages/de/collection/moodboards/moodboard";
import Avatar from "@mui/material/Avatar";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";

const avatarSize = 26;

const AdminMoodboards = () => {
  const [moodboards, setMoodboards] = useState([]);
  const [filteredMoodboards, setFilteredMoodboards] = useState([]);

  const location = useLocation();
  const url = location.href ? location.href : location.pathname + location.search;
  const urlObj = qs.parseUrl(url);
  const moodboard_id = urlObj?.query?.id;

  const user = useContext(AccountContext);

  useEffect(() => {
    retrieveMoodboards();
  }, []);

  const retrieveMoodboards = async () => {
    try {
      const { data } = await api.moodboard.adminList({ order: "-updated_at" });
      const myMoodboard = data?.moodboards || [];

      setMoodboards(myMoodboard);
      setFilteredMoodboards(myMoodboard);
    } catch (err) {
      toast.error(`Retrieve all moodboards failed!`);
      console.log(err);
    }
  };

  const getMoodboardRow = (item) => {
    const owner = item.owner || {};
    const storeInfo = owner?.stores?.[0] || {};
    const actions = [
      {
        label: (
          <Link to={`/a/moodboards?id=${item.id}`} style={{ color: "inherit" }}>
            View
          </Link>
        ),
        icon: <PageviewIcon fontSize={"small"} />,
      },
    ];
    return {
      key: item.id,
      image: item?.img,
      name: item.name,
      updated_at: item.updated_at,
      created_at: item?.created_at,
      owner: storeInfo,
      ownerName: storeInfo?.name,
      action: <Actionables actions={actions} />,
    };
  };

  const columns = [
    {
      Header: "Image",
      accessor: "image",
      align: "center",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return (
          <Link to={`/a/moodboards?id=${row?.original?.key}`}>
            <ImageCardWrapper data={value} mode={"normal"} height={60} width={60} iconMode />
          </Link>
        );
      },
    },
    {
      Header: "Name",
      accessor: "name",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return <div style={{ maxWidth: 400 }}>{value}</div>;
      },
    },
    {
      Header: "Updated Date",
      accessor: "updated_at",
      resizable: true,
      Cell: ({ row, value }) => {
        return (
          <Tooltip title={value ? moment(value).format("MM/DD/YY HH:mm:ss") : ""}>
            <div>{value ? moment(value).format("MM/DD/YY") : ""}</div>
          </Tooltip>
        );
      },
    },
    {
      Header: "Created Date",
      accessor: "created_at",
      Cell: ({ row, value }) => {
        return (
          <Tooltip title={value ? moment(value).format("MM/DD/YY HH:mm:ss") : ""}>
            <div>{value ? moment(value).format("MM/DD/YY") : ""}</div>
          </Tooltip>
        );
      },
    },
    {
      Header: "Owner",
      accessor: "ownerName",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return (
          <SuiBox
            display="flex"
            alignItems="center"
            justifyContent="center"
            color="inherit"
            sx={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/wall/portfolio/${row.original?.owner?.id}`);
            }}
          >
            <Avatar
              src={row.original?.owner?.metadata?.avatar}
              sx={{ width: avatarSize, height: avatarSize, mr: 0.5 }}
            />
            {value}
          </SuiBox>
        );
      },
    },
    { Header: "More", accessor: "action" },
  ];

  const moodboardRows = filteredMoodboards.map((item) => getMoodboardRow(item));

  if (moodboard_id) {
    return <Moodboard moodboard_id={moodboard_id} sharedView={true} />;
  }
  return (
    <Card sx={{ p: 3 }}>
      <DataTable
        table={{ columns, rows: moodboardRows }}
        entriesPerPage={{ defaultValue: 20 }}
        showTotalEntries={true}
        pagination={true}
        canSearch
      />
    </Card>
  );
};

export default AdminMoodboards;
